const PRODUCTION_HOSTNAME = 'app.amplorium.com'

export const isAnalyticsHost = (hostname: string = window.location.hostname): boolean =>
  hostname === PRODUCTION_HOSTNAME
